import { render, staticRenderFns } from "./Requisiciones.vue?vue&type=template&id=df58b60e"
import script from "./Requisiciones.vue?vue&type=script&lang=js"
export * from "./Requisiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports